import { render, staticRenderFns } from "./ImportSituationCell.vue?vue&type=template&id=0dd2ffc2&scoped=true"
import script from "./ImportSituationCell.vue?vue&type=script&lang=js"
export * from "./ImportSituationCell.vue?vue&type=script&lang=js"
import style0 from "./ImportSituationCell.vue?vue&type=style&index=0&id=0dd2ffc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2ffc2",
  null
  
)

export default component.exports